import {getGrpcConfig, StaticHostConfig} from '@aboutyou/config';
import {GrpcConfig, useStandaloneGrpcRequest} from '@aboutyou/data-fetcher';
import {CheckoutV1_getCheckoutDetailsLazy} from '@aboutyou/grpc-clients/grips/protos/checkout/checkout_v1.grpc.lazy';

export async function getCheckoutDetails({
  hash,
  staticHostConfig,
}: {
  hash: string;
  staticHostConfig: StaticHostConfig;
  grpcConfig: GrpcConfig;
}) {
  const {locale, device} = staticHostConfig;

  const legacyGrpcConfig = {
    shopId: staticHostConfig.legacyConfig.shopId,
    childShopId: staticHostConfig.legacyConfig.childShopId,
    device,
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const getData = useStandaloneGrpcRequest(
    {
      method: CheckoutV1_getCheckoutDetailsLazy,
      params: {
        hash,
      },
    },
    {
      legacy: true,
      hostConfig: {
        hostname: staticHostConfig.tadaridaUrl,
        legacyHostname: staticHostConfig.gripsUrl,
      },
      legacyGrpcConfig,
      grpcConfig: getGrpcConfig(locale, device),
    },
  );
  const data = await getData();

  return data;
}
